import { BucketType } from '@/gql/graphql';

export function bucketUserRole(
  userId: number | null,
  bucket: BucketType | null
): string | null {
  if (!userId || !bucket) {
    return null;
  }
  if (bucket.usersAssociated) {
    const assoc = bucket.usersAssociated.find((assoc) => {
      if (!assoc) return false;
      const assocUserId = assoc.userId || (assoc.user && assoc.user.id);
      if (!assocUserId) return false;
      return assocUserId === userId;
    });
    const role = assoc && assoc.userRole ? assoc.userRole : null;
    return role;
  }
  return null;
}
